import {
	a as e,
	d as t,
	f as n,
	i as r,
	l as i,
	n as a,
	s as o,
	t as s,
} from "./cart-surface-operations-CYhT-EGF.js";
import "./country-selector-DBC4D3VX.js";
(function () {
	let e = document.createElement(`link`).relList;
	if (e && e.supports && e.supports(`modulepreload`)) return;
	for (let e of document.querySelectorAll(`link[rel="modulepreload"]`)) n(e);
	new MutationObserver((e) => {
		for (let t of e)
			if (t.type === `childList`)
				for (let e of t.addedNodes)
					e.tagName === `LINK` && e.rel === `modulepreload` && n(e);
	}).observe(document, { childList: !0, subtree: !0 });
	function t(e) {
		let t = {};
		return (
			e.integrity && (t.integrity = e.integrity),
			e.referrerPolicy && (t.referrerPolicy = e.referrerPolicy),
			e.crossOrigin === `use-credentials`
				? (t.credentials = `include`)
				: e.crossOrigin === `anonymous`
					? (t.credentials = `omit`)
					: (t.credentials = `same-origin`),
			t
		);
	}
	function n(e) {
		if (e.ep) return;
		e.ep = !0;
		let n = t(e);
		fetch(e.href, n);
	}
})();
var c = `[data-main-cart]`,
	l = `input[data-cart-line]`,
	u = `[data-cart-quantity-change]`,
	d = `[data-cart-coupon]`,
	f = `[data-cart-coupon-form]`,
	p = `[data-cart-coupon-input]`,
	m = `[data-cart-coupon-reveal]`,
	h = `[data-cart-coupon-remove]`,
	g = `[data-cart-pending-checkout-code-remove]`,
	_ = `[data-cart-coupon-status]`,
	v = `[data-cart-checkout-form]`,
	y = `[data-cart-checkout-code]`,
	b = null,
	x = class x {
		abortController;
		cart;
		couponForm;
		couponInput;
		couponRemove;
		couponReveal;
		couponStatus;
		checkoutCodeInput;
		checkoutForm;
		form;
		pendingCheckoutCodeRemove;
		timers;
		constructor(e) {
			(this.cart = e),
				(this.form = e.querySelector(`.main-cart__form`)),
				(this.couponForm = e.querySelector(f)),
				(this.couponInput = e.querySelector(p)),
				(this.couponReveal = e.querySelector(m)),
				(this.couponRemove = e.querySelector(h)),
				(this.couponStatus = e.querySelector(_)),
				(this.pendingCheckoutCodeRemove = e.querySelector(g)),
				(this.checkoutForm = e.querySelector(v)),
				(this.checkoutCodeInput = e.querySelector(y)),
				(this.timers = new WeakMap()),
				(this.abortController = null),
				(this.handleInput = this.handleInput.bind(this)),
				(this.handleChange = this.handleChange.bind(this)),
				(this.handleClick = this.handleClick.bind(this)),
				(this.handleCouponReveal = this.handleCouponReveal.bind(this)),
				(this.handleCouponSubmit = this.handleCouponSubmit.bind(this)),
				(this.handleCouponRemove = this.handleCouponRemove.bind(this)),
				(this.handlePendingCheckoutCodeRemove =
					this.handlePendingCheckoutCodeRemove.bind(this)),
				(this.handleCheckoutSubmit = this.handleCheckoutSubmit.bind(this)),
				this.form?.addEventListener(`input`, this.handleInput),
				this.form?.addEventListener(`change`, this.handleChange),
				this.form?.addEventListener(`click`, this.handleClick),
				this.couponReveal?.addEventListener(`click`, this.handleCouponReveal),
				this.couponForm?.addEventListener(`submit`, this.handleCouponSubmit),
				this.couponRemove?.addEventListener(`click`, this.handleCouponRemove),
				this.pendingCheckoutCodeRemove?.addEventListener(
					`click`,
					this.handlePendingCheckoutCodeRemove,
				),
				this.checkoutForm?.addEventListener(
					`submit`,
					this.handleCheckoutSubmit,
				),
				this.restorePendingCheckoutCode(),
				(b = this);
		}
		handleInput(e) {
			let t = e.target.closest(l);
			t &&
				(clearTimeout(this.timers.get(t)),
				this.timers.set(
					t,
					window.setTimeout(() => this.updateLine(t), 450),
				));
		}
		handleChange(e) {
			let t = e.target.closest(l);
			t && (clearTimeout(this.timers.get(t)), this.updateLine(t));
		}
		handleClick(e) {
			if (!(e.target instanceof Element)) return;
			let t = e.target.closest(u);
			if (!t) return;
			let n = t.closest(`[data-cart-quantity-control]`)?.querySelector(l),
				r = Number.parseInt(t.dataset.cartQuantity ?? ``, 10),
				i = Number.parseInt(t.dataset.cartQuantityChange ?? ``, 10);
			!n ||
				!Number.isFinite(r) ||
				!Number.isFinite(i) ||
				((n.value = `${Math.max(1, r + i)}`), this.updateLine(n));
		}
		handleCouponReveal() {
			this.couponForm &&
				((this.couponForm.hidden = !1),
				this.couponReveal?.setAttribute(`aria-expanded`, `true`),
				this.couponReveal?.setAttribute(`hidden`, ``),
				this.couponInput?.focus());
		}
		handleCouponSubmit(e) {
			e.preventDefault();
			let t = this.couponInput?.value.trim() || ``;
			if (!t) {
				this.showCouponMessage(r(this.cart), !0);
				return;
			}
			this.updateCoupon(t);
		}
		handleCouponRemove() {
			this.updateCoupon(``);
		}
		handlePendingCheckoutCodeRemove() {
			a(),
				this.syncCheckoutCodeInput(``),
				this.cart
					.querySelector(d)
					?.classList.remove(`is-pending-checkout-code`),
				this.couponInput && (this.couponInput.value = ``),
				this.pendingCheckoutCodeRemove &&
					(this.pendingCheckoutCodeRemove.hidden = !0),
				this.showCouponMessage(``, !1),
				this.cart.querySelector(`[data-cart-coupon-applied]`) ||
					(this.couponForm && (this.couponForm.hidden = !0),
					this.couponReveal?.removeAttribute(`hidden`),
					this.couponReveal?.setAttribute(`aria-expanded`, `false`));
		}
		handleCheckoutSubmit() {
			this.syncCheckoutCodeInput(e());
		}
		async updateLine(e) {
			let t = Number.parseInt(e.dataset.cartLine, 10),
				n = Number.parseInt(e.dataset.cartQuantity, 10),
				r = Number.parseInt(e.value, 10);
			if (!Number.isFinite(t) || !Number.isFinite(n)) return;
			if (!Number.isFinite(r)) {
				e.value = `${n}`;
				return;
			}
			let i = Math.max(1, r);
			if (((e.value = `${i}`), i === n)) return;
			this.abortController?.abort();
			let a = new AbortController();
			(this.abortController = a), this.setPending(!0);
			try {
				let e = await s({
					currentRoot: this.cart,
					rootSelector: c,
					sectionId: this.cart.dataset.sectionId,
					eventSource: `main-cart`,
					line: t,
					quantity: i,
					signal: a.signal,
				});
				if (!e.ok) throw Error(e.message);
				new x(e.root);
			} catch (e) {
				if (e.name === `AbortError`) return;
				console.warn(`Unable to update cart`, e);
			} finally {
				a.signal.aborted || this.setPending(!1);
			}
		}
		async updateCoupon(i) {
			this.setPending(!0);
			try {
				let o = await t({
						currentRoot: this.cart,
						rootSelector: c,
						couponSelector: d,
						sectionId: this.cart.dataset.sectionId,
						eventSource: `main-cart`,
						code: i,
					}),
					s =
						(o.root || this.cart) === this.cart
							? this
							: new x(o.root || this.cart);
				if (!o.ok) {
					if (o.reason === `invalid_coupon` && i) {
						s.setPending(!0);
						let e = await n(i, r(s.cart));
						s.setPending(!1),
							e.ok
								? s.showPendingCheckoutCode(i)
								: (a(), s.showCouponMessage(e.message, !0));
						return;
					}
					s.showCouponMessage(o.message, !0);
					return;
				}
				if (o.removed && e()) s.restorePendingCheckoutCode();
				else {
					let e = o.removed
						? ``
						: s.cart.dataset.couponSuccessMessage || `Coupon code toegepast.`;
					s.showCouponMessage(e, !1);
				}
			} catch (e) {
				this.showCouponMessage(e.message, !0),
					console.warn(`Unable to update coupon code`, e);
			} finally {
				this.setPending(!1);
			}
		}
		async refresh() {
			let e = await o({
				currentRoot: this.cart,
				rootSelector: c,
				sectionId: this.cart.dataset.sectionId,
			});
			if (!e.ok) throw Error(e.message);
			new x(e.root);
		}
		setPending(e) {
			this.cart.querySelectorAll(`button, input`).forEach((t) => {
				t.toggleAttribute(`aria-busy`, e), (t.disabled = e);
			});
		}
		showCouponMessage(e, t = !1) {
			this.couponStatus &&
				((this.couponStatus.textContent = e || ``),
				this.couponStatus.classList.toggle(`is-error`, !!t));
		}
		showPendingCheckoutCode(e) {
			let t = i(e);
			t &&
				(this.syncCheckoutCodeInput(t),
				this.cart.querySelector(d)?.classList.add(`is-pending-checkout-code`),
				this.couponInput && (this.couponInput.value = t),
				this.couponForm && (this.couponForm.hidden = !1),
				this.couponReveal?.setAttribute(`hidden`, ``),
				this.couponReveal?.setAttribute(`aria-expanded`, `true`),
				this.pendingCheckoutCodeRemove &&
					(this.pendingCheckoutCodeRemove.hidden = !1),
				this.showCouponMessage(
					this.cart.dataset.checkoutCodePendingMessage ||
						`Code toegevoegd. Deze wordt toegepast bij het afrekenen.`,
					!1,
				));
		}
		restorePendingCheckoutCode() {
			let t = e();
			t && this.showPendingCheckoutCode(t);
		}
		syncCheckoutCodeInput(e) {
			if (!this.checkoutCodeInput) return;
			let t = String(e || ``).trim();
			(this.checkoutCodeInput.value = t),
				t
					? (this.checkoutCodeInput.name = `checkout[reduction_code]`)
					: this.checkoutCodeInput.removeAttribute(`name`);
		}
	};
document.querySelectorAll(c).forEach((e) => {
	new x(e);
}),
	document.addEventListener(`cart:updated`, (e) => {
		e.detail?.source !== `main-cart` &&
			b?.refresh().catch((e) => {
				console.warn(`Unable to refresh cart page`, e);
			});
	});
